module.exports = __webpack_public_path__ + "img/story-3.79679248.png";